import React from 'react';

import { COMPONENTS, SECTIONS } from 'components/Globals/Analytics/constants';
import SectionBlock from 'components/Globals/SectionBlock';
import ProductionListView from 'components/Productions/Common/ProductionListView';

import { TP, ENTITY_MAIN_TABS } from 'constants/index';

import usePageContext from 'utils/hooks/usePageContext';

import { useTranslation } from 'src/i18n';

import { VIEW_MODES } from 'operabase-router/constants';

import classes from './EntityRentalsList.module.scss';

const trackingData = {
  section: SECTIONS.RENTALS_LISTING,
};

const EntityRentalsList = ({ entityType, entity, limit = 12, disabled = false, enableSeeAll, title, isOverview }) => {
  const { t } = useTranslation('NS_DISPLAY_V4');
  const { navigate } = usePageContext();

  return (
    <div className={classes.root}>
      <SectionBlock
        title={title || t(`${TP}.FN_PRODUCTION_AVAILABLE_FOR_RENT`)}
        enableDivider
        enableSeeAll={enableSeeAll}
        {...(enableSeeAll && {
          linkProps: {
            ...navigate.getLinkProps({ entityType, entity, path: ENTITY_MAIN_TABS.RENTALS }),
            title: t('VIEW_ALL_PRODUCTION_RENTALS'),
          },
        })}
        enableViewAllButton={isOverview}
        seeAllTrackingData={{ ...trackingData, component: COMPONENTS.SEE_ALL_CTA }}
      >
        <ProductionListView
          limit={limit}
          trackingData={trackingData}
          styles={{ filterContainer: classes.filterContainer }}
          infinite={!disabled}
          overrideFilters={{
            has_active_rental: true,
          }}
          forcedViewMode={VIEW_MODES.GRID}
          hideActions
        />
      </SectionBlock>
    </div>
  );
};

export default EntityRentalsList;
